<div class="banner" [ngStyle]="{ 'background-color': message[0]?.systemMessageColor }" *ngIf="message?.length > 0" (click)="showMessage()">
    {{ message[0]?.messageTitle }}
</div>
